module.exports = __webpack_public_path__ + "static/img/dizhi.e476825.gif";


//////////////////
// WEBPACK FOOTER
// ./static/dizhi.gif
// module id = UhG6
// module chunks = 1